import { render, staticRenderFns } from "./books-list.vue?vue&type=template&id=3e464e49"
import script from "./books-list.vue?vue&type=script&lang=js"
export * from "./books-list.vue?vue&type=script&lang=js"
import style0 from "./books-list.vue?vue&type=style&index=0&id=3e464e49&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports